export default "__VITE_ASSET__ae6d8cab__"